export function getInventoryGroups() {
  return {
    type: 'GET_INVENTORY_GROUPS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/inventory/getInventoryGroups',
            mock: false,
          },
        },
        commit: {
          type: `GET_INVENTORY_GROUPS_COMMIT`,
        },
        rollback: {
          type: 'GET_INVENTORY_GROUPS_ROLLBACK',
        },
      },
    },
  }
}

export function getInventoryGroup(id) {
  return {
    type: 'GET_INVENTORY_GROUP',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/inventory/inventoryGroup',
            mock: false,
            query: [
              {
                name: 'id',
                value: id,
              },
            ],
          },
        },
        commit: {
          type: `GET_INVENTORY_GROUP_COMMIT`,
        },
        rollback: {
          type: 'GET_INVENTORY_GROUP_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryGroupSave(data) {
  return {
    type: 'SAVE_INVENTORY_GROUP',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/inventory/inventoryGroup',
          },
        },
        commit: {
          type: 'SAVE_INVENTORY_GROUP_COMMIT',
          payload: data,
        },
        rollback: {
          type: 'SAVE_INVENTORY_GROUP_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryGroupDelete(id) {
  return {
    type: 'DELETE_INVENTORY_GROUP',
    payload: {
      id,
    },
    meta: {
      offline: {
        effect: {
          method: 'DELETE',
          query: {
            mock: false,
            base: '/inventory/inventoryGroup',
          },
        },
        commit: {
          type: 'DELETE_INVENTORY_GROUP_COMMIT',
          payload: id,
        },
        rollback: {
          type: 'DELETE_INVENTORY_GROUP_ROLLBACK',
        },
      },
    },
  }
}

export function getInventoryItem(id) {
  return {
    type: 'GET_INVENTORY_ITEM',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/inventory/inventoryItem',
            mock: false,
            query: [
              {
                name: 'id',
                value: id,
              },
            ],
          },
        },
        commit: {
          type: `GET_INVENTORY_ITEM_COMMIT`,
        },
        rollback: {
          type: 'GET_INVENTORY_ITEM_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryItemSave(data) {
  return {
    type: 'SAVE_INVENTORY_ITEM',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/inventory/inventoryItem',
          },
        },
        commit: {
          type: 'SAVE_INVENTORY_ITEM_COMMIT',
        },
        rollback: {
          type: 'SAVE_INVENTORY_ITEM_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryItemDelete(id) {
  return {
    type: 'DELETE_INVENTORY_ITEM',
    payload: {
      id,
    },
    meta: {
      offline: {
        effect: {
          method: 'DELETE',
          query: {
            mock: false,
            base: '/inventory/inventoryItem',
          },
        },
        commit: {
          type: 'DELETE_INVENTORY_ITEM_COMMIT',
          payload: id,
        },
        rollback: {
          type: 'DELETE_INVENTORY_ITEM_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryFileDelete(id = null, url = null) {
  return {
    type: 'DELETE_INVENTORY_FILE',
    payload: {
      id,
      url,
    },
    meta: {
      offline: {
        effect: {
          method: 'DELETE',
          query: {
            mock: false,
            base: '/inventory/inventoryFile',
          },
        },
        commit: {
          type: 'DELETE_INVENTORY_FILE_COMMIT',
        },
        rollback: {
          type: 'DELETE_INVENTORY_FILE_ROLLBACK',
        },
      },
    },
  }
}

export function inventoryNewItemFilesAdd(file) {
  return {
    type: 'NEW_ITEM_FILES_ADD',
    payload: {
      file,
    },
  }
}

export function inventoryNewItemFilesRemove(file) {
  return {
    type: 'NEW_ITEM_FILES_REMOVE',
    payload: {
      file,
    },
  }
}

export function inventoryNewItemFilesClear() {
  return {
    type: 'NEW_ITEM_FILES_CLEAR',
  }
}

export function inventorySetItemAddedDisclaimerFalse() {
  return {
    type: 'SET_ITEM_ADDED_DISCLAIMER_FALSE',
  }
}

export function inventoryExport(data) {
  return {
    type: 'INVENTORY_EXPORT',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/inventory/inventoryExport',
          },
        },
        commit: {
          type: 'INVENTORY_EXPORT_COMMIT',
        },
        rollback: {
          type: 'INVENTORY_EXPORT_ROLLBACK',
        },
      },
    },
  }
}
